module.exports = __webpack_public_path__ + "media/packs/compcalc/components/icons/future-value-dd7ac0afc36cfa0b1b1073892ca1d1f5.png";